import { createSlice } from '@reduxjs/toolkit';
import { mapKeys } from 'lodash-es';
import { createAsyncAction } from '../action';
import { Status } from '.';

const getAllReports = createAsyncAction('getAllReports', 'getAllReports');
const getFilteredReports = createAsyncAction('getFilteredReports', 'getFilteredReports');
const downloadReport = createAsyncAction('downloadReport', 'downloadReport');
const downloadFilteredReports = createAsyncAction('downloadFilteredReports', 'downloadFilteredReports');
const downloadCandidatesReports = createAsyncAction('downloadCandidatesReports', 'downloadCandidatesReports');

interface IInitialState {
  isFetchingReports: boolean;
  isFetchingFilteredReports: boolean;
  fetchingReportsError: string;
  downloadReportLink: string;
  downloadReportStatus: string;
  candidatesReportsDownloadLink: string;
  candidatesReportsDownloadStatus: string;
  downloadFilteredReportsLink: string;
  downloadFilteredReportsStatus: string;
  totalReports: number;
  reportsPerPage: number;
  totalPages: number;
  reports: any;
  reportByCheckupId: any;
}

const initialState: IInitialState = {
  isFetchingReports: false,
  isFetchingFilteredReports: false,
  fetchingReportsError: '',
  downloadReportLink: '',
  downloadReportStatus: '',
  candidatesReportsDownloadLink: '',
  candidatesReportsDownloadStatus: '',
  downloadFilteredReportsLink: '',
  downloadFilteredReportsStatus: '',
  totalReports: 0,
  reportsPerPage: 20,
  totalPages: 1,
  reports: [],
  reportByCheckupId: {},
};

export const counterSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    updateReportState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getAllReports.pending as any]: (state) => {
      state.isFetchingReports = true;
    },
    [getAllReports.fulfilled as any]: (state, { payload }) => {
      const { candidate_checkup_list = [], total, total_pages, page_number } = payload?.data || {};
      state.isFetchingReports = false;
      state.reports = candidate_checkup_list || [];
      state.totalReports = total || state.reports?.length;
      state.reportsPerPage = page_number === 1 ? candidate_checkup_list?.length : state.reportsPerPage;
      state.totalPages = total_pages || 1;
      state.reportByCheckupId = mapKeys(state.reports, 'qsrCheckupId');
    },
    [getAllReports.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingReports = false;
      }
    },

    [getFilteredReports.pending as any]: (state) => {
      state.isFetchingFilteredReports = true;
    },
    [getFilteredReports.fulfilled as any]: (state, { payload }) => {
      const { candidate_checkup_list = [], total, total_pages, page_number } = payload?.data || {};
      state.isFetchingFilteredReports = false;
      state.reports = candidate_checkup_list || [];
      state.totalReports = total || state.reports?.length;
      state.reportsPerPage = page_number === 1 ? candidate_checkup_list?.length : state.reportsPerPage;
      state.totalPages = total_pages || 1;
      state.reportByCheckupId = mapKeys(state.reports, 'qsrCheckupId');
    },
    [getFilteredReports.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingFilteredReports = false;
      }
    },

    [downloadReport.pending as any]: (state) => {
      state.downloadReportLink = '';
      state.downloadReportStatus = Status.pending;
    },
    [downloadReport.fulfilled as any]: (state, { payload }) => {
      state.downloadReportLink = window.URL.createObjectURL(new Blob([payload], { type: 'application/pdf' }));
      state.downloadReportStatus = Status.fulfilled;
    },
    [downloadReport.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.downloadReportLink = '';
        state.downloadReportStatus = Status.rejected;
      }
    },

    [downloadFilteredReports.pending as any]: (state) => {
      state.downloadFilteredReportsLink = '';
      state.downloadFilteredReportsStatus = Status.pending;
    },
    [downloadFilteredReports.fulfilled as any]: (state, { payload }) => {
      state.downloadFilteredReportsLink = window.URL.createObjectURL(new Blob([payload], { type: 'application/csv' }));
      state.downloadFilteredReportsStatus = Status.fulfilled;
    },
    [downloadFilteredReports.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.downloadFilteredReportsLink = '';
        state.downloadFilteredReportsStatus = Status.rejected;
      }
    },

    [downloadCandidatesReports.pending as any]: (state) => {
      state.candidatesReportsDownloadLink = '';
      state.candidatesReportsDownloadStatus = Status.pending;
    },
    [downloadCandidatesReports.fulfilled as any]: (state, { payload }) => {
      state.candidatesReportsDownloadLink = window.URL.createObjectURL(new Blob([payload], { type: 'application/zip' }));
      state.candidatesReportsDownloadStatus = Status.fulfilled;
    },
    [downloadCandidatesReports.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.candidatesReportsDownloadLink = '';
        state.candidatesReportsDownloadStatus = Status.rejected;
      }
    },
  },
});

const { updateReportState } = counterSlice.actions;
export {
  updateReportState,
  getAllReports,
  getFilteredReports,
  downloadReport,
  downloadFilteredReports,
  downloadCandidatesReports,
};
export default counterSlice.reducer;
